const Immutable = require('immutable');
const createSelector = require('./createSelector');
const programListSelector = require('./programListSelector');
const programListFiltersSelector = (state) => state.getIn(['resources', 'pages', 'programs', 'meta', 'filters'], Immutable.List());
const programListCategoriesSelector	= (state) => state.getIn(['resources', 'pages', 'programs', 'meta', 'categories'], Immutable.List());

const FILTER_ALL = 'program';
const FILTER_CURRENT = 'aktuella';
const FILTER_PLAY = 'play';

const CATEGORY_DOCUMENTARY = 'documentary';
const CATEGORY_FILMANDDRAMA = 'filmAndDrama';
const CATEGORY_CULTUREANDENTERTAINMENT = 'cultureAndEntertainment';
const CATEGORY_SOCIETYANDFACTS = 'societyAndFacts';
const CATEGORY_NEWS = 'news';
const CATEGORY_SPORT = 'sport';
const CATEGORY_WEATHER = 'weather';
const CATEGORY_KIDS = 'kids';

const CATEGORIES = Immutable.List([
	CATEGORY_DOCUMENTARY,
	CATEGORY_FILMANDDRAMA,
	CATEGORY_CULTUREANDENTERTAINMENT,
	CATEGORY_SOCIETYANDFACTS,
	CATEGORY_NEWS,
	CATEGORY_SPORT,
	CATEGORY_WEATHER,
	CATEGORY_KIDS
]);

const LABEL = {};
LABEL[FILTER_ALL]												= 'Alla';
LABEL[FILTER_CURRENT]										= 'Aktuella';
LABEL[FILTER_PLAY]											= 'Tillgängliga i Play';
LABEL[CATEGORY_DOCUMENTARY]							= 'Dokumentär';
LABEL[CATEGORY_FILMANDDRAMA]						= 'Film & Drama';
LABEL[CATEGORY_CULTUREANDENTERTAINMENT]	= 'Kultur & Nöje';
LABEL[CATEGORY_SOCIETYANDFACTS]					= 'Samhälle & Fakta';
LABEL[CATEGORY_NEWS]										= 'Nyheter';
LABEL[CATEGORY_SPORT]										= 'Sport';
LABEL[CATEGORY_WEATHER]									= 'Väder';
LABEL[CATEGORY_KIDS]										= 'Barn';

const KEYS ={};
KEYS[CATEGORY_DOCUMENTARY]							= 'dokumentar';
KEYS[CATEGORY_FILMANDDRAMA]							= 'filmochdrama';
KEYS[CATEGORY_CULTUREANDENTERTAINMENT]	= 'kulturochnoje';
KEYS[CATEGORY_SOCIETYANDFACTS]					= 'samhalleochfakta';
KEYS[CATEGORY_NEWS]											= 'nyheter';
KEYS[CATEGORY_SPORT]										= 'sport';
KEYS[CATEGORY_WEATHER]									= 'vader';
KEYS[CATEGORY_KIDS]											= 'barn';

function normalize(key) {
	return KEYS[key] || key;
}


const programListAllCategoriesSelector = createSelector(
	[programListSelector],
	(values) => values.reduce((categories, program) => categories.withMutations((map) => {
		return program.get('categories', Immutable.List()).reduce((map, categori) => map.set(categori, true), map);
	}), Immutable.Map())
);

const INVALID_FIRST_CHAR = /^[^0-9a-zA-ZåäöÅÄÖ]+/;
const NUMERIC_FIRST_CHAR = /^[0-9]+/;

function programTitleComparator(a, b) {
		var ca = a.charAt(0);
		var cb = b.charAt(0);

		if( isNaN(ca) && !isNaN(cb)) { return -1; }
		if(!isNaN(ca) &&  isNaN(cb)) { return  1; }
		if( ca === 'å' && cb === 'ä') { return -1; }
		if( ca === 'ä' && cb === 'å') { return 1; }

		return a < b ? -1 : a > b ? 1 : 0;
}

const programListGroupedSelector = createSelector(
	[programListSelector],
	(values) => {
		return values.sortBy( function(item) {
								return item.get('title','').toLowerCase().replace(INVALID_FIRST_CHAR,'');
							}, programTitleComparator)
							.groupBy( function(item) {
								var title = item.get('title', '').replace(INVALID_FIRST_CHAR,'');
								return NUMERIC_FIRST_CHAR.test(title)? '0-9' : title.charAt(0).toLowerCase();
							})
							.sortBy(function(group, key) {
								return key;
							}, programTitleComparator);
	}
);

const programListFilteredSelector = createSelector(
	[
		programListGroupedSelector,
		programListFiltersSelector,
		programListCategoriesSelector
	],
	(groups, filters, categories) => {

		if(filters.contains(FILTER_ALL)) {
			filters = Immutable.List();
		}
		if(categories.isEmpty() && filters.isEmpty()) {
			return groups;
		}

		return groups.map(function mapProgramGroup(group) {
			return group.filter(function filterProgramGroupItem(item) {
				if(filters.contains(FILTER_PLAY) && item.get('play', false) === false) {
					return false;
				}

				if(filters.contains(FILTER_CURRENT) && item.get('current', false) === false) {
					return false;
				}

				if(categories.isEmpty()) {
					return true;
				}

				try {
					return item.get('categories', Immutable.List())
						.map(function(key) { return normalize(key); })
						.reduce( function(reduction, value) { return reduction? true: categories.contains(value); }, false);
				} catch (err) {
					// console.log('err parsing item %o', item);
					return false;
				}
			});
		});
	}
);

const programListActiveCategoriesSelector = createSelector(
	[
		programListAllCategoriesSelector,
		programListCategoriesSelector
	],
	(categories, active) => {
		return CATEGORIES
			.filter((category) => categories.has(category))
			.map((category) => {
				const name = normalize(category);
				const isActive = active.contains(name);
				return Immutable.Map({
					id: category,
					title: LABEL[category],
					isActive: isActive,
					toggleQuery: isActive ? active.filterNot((value) => value === name).sort().join(',') : active.concat(name).sort().join(',')
				});
			});
	}
);

const programListActiveFiltersSelector = createSelector(
	[programListFiltersSelector],
	(filters) => {
		return Immutable.fromJS([
			{
				id:FILTER_ALL,
				title : LABEL[FILTER_ALL],
				toggleQuery : FILTER_ALL,
				isActive : false
			},
			{
				id :FILTER_CURRENT,
				title : LABEL[FILTER_CURRENT],
				toggleQuery : FILTER_CURRENT,
				isActive : true
			},
			{
				id : FILTER_PLAY,
				title : LABEL[FILTER_PLAY],
				toggleQuery : FILTER_PLAY,
				isActive : false
			}]).map((item) => {
				return filters.contains(item.get('id'))? item.set('isActive', true) : item.set('isActive', false);
			});
	}
);

const programsSelector = createSelector(
	[
		programListFilteredSelector,
		programListActiveCategoriesSelector,
		programListActiveFiltersSelector
	],
	(programs, categories, filters) => {
		return Immutable.Map().withMutations((map) => {
			map.set('programs', programs);
			map.set('categories', categories);
			map.set('filters', filters);
			map.set('highlite', categories.some((value) => value.get('isActive') === true));
			return map;
		});
	}
);

module.exports = programsSelector;



/** WEBPACK FOOTER **
 ** ./app/selectors/programsSelector.js
 **/